import nodeType from "./node-type.vue";
const defaultData = {
    nodes: [{
            conditionType: 2,
            id: "118fe5c2-9e0d",
            img: true,
            left: 412.001708984375,
            nodeType: 3,
            operator: "4",
            render: nodeType,
            testName: "定量类型",
            top: 177.00347137451172,
            value: "10",
            valueUnit: "1",
            endpoints: [{
                    id: "top",
                    orientation: [0, -1] //下: [0,1]上: [0,-1]右: [1,0]左: [-1,0]
                },
                {
                    id: "bottom",
                    orientation: [0, 1]
                },
                {
                    id: "left",
                    orientation: [-1, 0] //下: [0,1]上: [0,-1]右: [1,0]左: [-1,0]
                },
                {
                    id: "right",
                    orientation: [1, 0]
                }
            ]
        },
        {
            conditionType: 4,
            id: "5436298b-6553",
            img: true,
            left: 260.001708984375,
            nodeType: 3,
            operator: "3",
            render: nodeType,
            testName: "绝对类型",
            top: 319.0034713745117,
            value: "",
            valueUnit: "",
            endpoints: [{
                    id: "top",
                    orientation: [0, -1] //下: [0,1]上: [0,-1]右: [1,0]左: [-1,0]
                },
                {
                    id: "bottom",
                    orientation: [0, 1]
                },
                {
                    id: "left",
                    orientation: [-1, 0] //下: [0,1]上: [0,-1]右: [1,0]左: [-1,0]
                },
                {
                    id: "right",
                    orientation: [1, 0]
                }
            ]
        },
        {
            id: "246481e9-74c0",
            img: true,
            left: 300.001708984375,
            nodeType: 4,
            notifyRole: 3,
            notifyType: 1,
            render: nodeType,
            showCon: "(全病程房间) 患者",
            testName: "通知类型",
            top: 512.0034713745117,
            endpoints: [{
                id: "top",
                orientation: [0, -1] //下: [0,1]上: [0,-1]右: [1,0]左: [-1,0]
            }]
        },
        {
            conditionType: 4,
            id: "befd94f0-cb6e",
            img: true,
            left: 568.001708984375,
            nodeType: 3,
            operator: "6",
            render: nodeType,
            testName: "绝对类型",
            top: 319.0034713745117,
            value: "",
            valueUnit: "",
            endpoints: [{
                    id: "top",
                    orientation: [0, -1] //下: [0,1]上: [0,-1]右: [1,0]左: [-1,0]
                },
                {
                    id: "bottom",
                    orientation: [0, 1]
                },
                {
                    id: "left",
                    orientation: [-1, 0] //下: [0,1]上: [0,-1]右: [1,0]左: [-1,0]
                },
                {
                    id: "right",
                    orientation: [1, 0]
                }
            ]
        },
        {
            id: "7a6ab877-15ac",
            img: true,
            left: 608.001708984375,
            nodeType: 4,
            notifyRole: 1,
            notifyType: 1,
            render: nodeType,
            showCon: "(全病程房间) 个案管理师、患者",
            testName: "通知类型",
            top: 510.0034713745117,
            endpoints: [{
                id: "top",
                orientation: [0, -1] //下: [0,1]上: [0,-1]右: [1,0]左: [-1,0]
            }]
        },
        {
            fieldCode: 30003,
            fieldName: "血压-收缩压\t",
            id: "f0cb425d-5ae6",
            img: true,
            left: 448.001708984375,
            nodeType: 1,
            render: nodeType,
            testName: "血压-收缩压\t",
            top: 45.00347137451172,
            endpoints: [{
                    id: "top",
                    orientation: [0, -1] //下: [0,1]上: [0,-1]右: [1,0]左: [-1,0]
                },
                {
                    id: "bottom",
                    orientation: [0, 1]
                }
            ]
        },
        {
            displayContent: "辅助生殖技术（ART）过程中应急情况",
            id: "40e33d6f-f8b8",
            img: true,
            left: 825.001708984375,
            nodeType: 2,
            outputContent: "",
            outputType: 3,
            render: nodeType,
            top: 313.0034713745117,
            endpoints: [{
                    id: "top",
                    orientation: [0, -1] //上: [0,-1] 下: [0,1] 左: [-1,0] 右: [1,0]
                    //pos: [0.5, 0] // 锚点位置 [0-1之间 , 0-1之间]，0代表最左/上侧，1代表最右/下侧
                },
                {
                    id: "right",
                    orientation: [1, 0]
                },
                {
                    id: "bottom",
                    orientation: [0, 1]
                },
                {
                    id: "left",
                    orientation: [-1, 0]
                }
            ]
        }
    ],
    groups: [],
    edges: [{
            id: "f0cb425d-5ae6.bottom-118fe5c2-9e0d.top",
            source: "bottom",
            sourceNode: "f0cb425d-5ae6",
            target: "top",
            targetNode: "118fe5c2-9e0d"
        },
        {
            id: "118fe5c2-9e0d.bottom-5436298b-6553.top",
            source: "bottom",
            sourceNode: "118fe5c2-9e0d",
            target: "top",
            targetNode: "5436298b-6553"
        },
        {
            id: "118fe5c2-9e0d.bottom-befd94f0-cb6e.top",
            source: "bottom",
            sourceNode: "118fe5c2-9e0d",
            target: "top",
            targetNode: "befd94f0-cb6e"
        },
        {
            id: "5436298b-6553.bottom-246481e9-74c0.top",
            source: "bottom",
            sourceNode: "5436298b-6553",
            target: "top",
            targetNode: "246481e9-74c0"
        },
        {
            id: "befd94f0-cb6e.bottom-7a6ab877-15ac.top",
            source: "bottom",
            sourceNode: "befd94f0-cb6e",
            target: "top",
            targetNode: "7a6ab877-15ac"
        },
        {
            id: "befd94f0-cb6e.right-40e33d6f-f8b8.left",
            source: "right",
            sourceNode: "befd94f0-cb6e",
            target: "left",
            targetNode: "40e33d6f-f8b8"
        }
    ]
}
export default defaultData 